import React, { useEffect, useState } from 'react';
import {Button, Pagination, Popconfirm, Modal, Form, Input, Switch, message } from 'antd';
import Loader from '../../common/loader/Loader';
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs';
import { addPaymentMethod, deletePaymentMethod, getPaymentMethod , updatePaymentMethod } from '../../api/login/Login';

const breadCrumbsTitle = {
  id: '1',
  title_1: 'Master',
  path_1: '/admin/master/payment-method-master',
  title_2: 'Payment Method Type',
};

const PaymentMethodType = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pageNo, setPageNo] = useState(1); // ✅ page number
  const [totalData, setTotalData] = useState(0); // ✅ total count
  const [limit] = useState(10); // ✅ page size (constant)
  const [resetKey, setResetKey] = useState(false); // ✅ to trigger re-fetch

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [form] = Form.useForm();

  // ✅ Fetch data function
  const fetchData = async () => {
    let body = {
      page:pageNo,
      limit:limit
    }
    // setLoading(true);
    try {
      const response = await getPaymentMethod(body)
      console.log(response)
      setData(response.data.data || []);
      setTotalData(response?.data?.data?.length || 0); // ✅ update total count
    } catch (error) {
      // message.error('Failed to fetch data');
    }
    // setLoading(false);
  };

  // ✅ On mount & when resetKey OR pageNo changes
  useEffect(() => {
    fetchData();
  }, [resetKey, pageNo]);

  // ✅ Add new item
  const handleAdd = () => {
    setCurrentItem(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  // ✅ Edit item
  const handleEdit = (item) => {
    setCurrentItem(item);
    form.setFieldsValue({
      type: item.type,
      status: item.is_active,
    });
    setIsModalVisible(true);
  };

  // ✅ Delete item
  const handleDelete = async (id) => {
    setLoading(true);
    // deleteTransactionType()
    try {
     let res  =  await deletePaymentMethod(id)
     if(res?.error === false)
      {
       message.success(res?.message);
       setResetKey(prev => !prev); 
      }
      else {
       message.error(res?.message);
      }
   
      
    } catch (error) {
     
    }
    setLoading(false);
  };

  // ✅ Submit (Add or Edit)
  const handleOk = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
       let res 
  
      if (currentItem) {
        // Update
         res  = await  updatePaymentMethod({id:currentItem._id , ...values})
       
      } else {
        // Add new
        res = await addPaymentMethod(values)
      }
      if(res?.error === false)
        {
         setIsModalVisible(false);
         message.success(res?.message);
         setResetKey(prev => !prev); 
        }
        else {
         message.error(res?.message);
        }
     
      console.log(res , "res")
    } catch (error) {
      // message.error('Operation failed');
    } finally {
    
      setLoading(false);
    }
    
  };

  return (
    <>
      <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
      {loading && <Loader />}
      <div className="row m-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-responsive active-projects style-1">
                <div className="tbl-caption d-flex justify-content-between align-items-center">
                  <h4 className="heading mb-0">Payment Method</h4>
                  {/* <button type="button" className="btn btn-secondary btn-sm" onClick={handleAdd}>
                    Add Transaction Type
                  </button> */}
                  <Button type="primary" size="small" onClick={handleAdd}>
                  + Add Payment Method
                </Button>
                </div>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((item) => (
                        <tr key={item._id}>
                          <td>{item.type}</td>
                          <td>
                            <span className={`badge ${item.is_active ? 'bg-success' : 'bg-danger'}`}>
                              {item.is_active ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex">
                              <button
                                onClick={() => handleEdit(item)}
                                className="btn btn-primary btn-xs sharp me-2"
                              >
                                <i className="fa fa-pencil" />
                              </button>
                              <Popconfirm
                                title="Delete Payment Method?"
                                onConfirm={() => handleDelete(item._id)}
                                okText="Yes"
                                cancelText="No"
                              >
                                <button className="btn btn-danger btn-xs sharp">
                                  <i className="fa fa-trash" />
                                </button>
                              </Popconfirm>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No data found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>Total {totalData} entries</div>
                  <Pagination
                    current={pageNo}
                    total={totalData}
                    pageSize={limit}
                    onChange={(page) => setPageNo(page)} // ✅ update pageNo state
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={currentItem ? 'Update Payment Method' : 'Add Payment Method'}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={() => setIsModalVisible(false)}
        okText={currentItem ? 'Update' : 'Add'}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="type"
            label="Name"
            rules={[
              {
                validator: (_, value) => {
                  if (!value || value.trim() === '') {
                    return Promise.reject(new Error('Please input a valid payment method name!'));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
  name="status"
  label="Status"
  valuePropName="checked"
  style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}
>
  <Switch
    checkedChildren="Active"
    unCheckedChildren="Inactive"
    className="custom-switch"
  />
</Form.Item>

        </Form>
      </Modal>
    </>
  );
};

export default PaymentMethodType;

